import React from "react";
import { PenLine } from "lucide-react";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";
import SubmitForm from "../components/SubmitForm";

export default function ContributePage() {
  const { t } = useLang();
  useDocumentTitle(t("Quero contribuir · ReiMultiBlog", "Contribute · ReiMultiBlog"),
    t("Partilha a tua experiência e contribui com conteúdo.", "Share your experience and contribute content."));
  return (
    <InfoLayout title={t("Quero contribuir", "I want to contribute")} crumb={t("Contribuir", "Contribute")}
      subtitle={t("Tens experiência para partilhar? Junta-te a nós.", "Have experience to share? Join us.")}>
      <div className="not-prose flex items-center gap-2 text-primary mb-4"><PenLine className="h-5 w-5" /><span className="text-sm font-semibold">{t("Procuramos quem viveu estas experiências.", "We're looking for people who lived these experiences.")}</span></div>
      <p>{t("Preenche o formulário com o tema que dominas e uma breve descrição sobre ti. Entramos em contacto.", "Fill in the form with the topic you master and a short description about yourself. We'll reach out.")}</p>
      <SubmitForm
        type="contribution"
        showEmail emailRequired
        subjectLabel={t("Tema que dominas", "Topic you master")}
        messageLabel={t("Breve descrição pessoal", "Short personal description")}
        subjectPlaceholder={t("ex.: Impostos para freelancers na Suíça", "e.g. Taxes for freelancers in Switzerland")}
        messagePlaceholder={t("Conta-nos um pouco sobre ti e a tua experiência…", "Tell us a bit about you and your experience…")}
        buttonLabel={t("Quero contribuir", "I want to contribute")}
      />
    </InfoLayout>
  );
}
